<template>
  <div id="group-wrap">
    <div id="header" class="yp-topbar">
      <div v-show="!isChoose" class="topbar">
        <div class="top-left">
          <i class="back" @click="returnBack"></i>
        </div>
        <div class="top-center">群组管理</div>
        <div class="top-right">
          <i class="open-mobile" @click="isDialogShow = true"></i>
          <i class="check-mobile" @click="triggerChoose"></i>
        </div>
      </div>
      <div v-show="isChoose" class="topbar">
        <div class="top-left">
          <span @click="choose">
          {{isChooseAll ? '取消全选' : '全选'}}
          </span>
        </div>
        <div class="top-center" v-show="selectCount > 0">已选{{selectCount}}个群组</div>
        <div class="top-right">
          <span @click="cancle">取消</span>
        </div>
      </div>
    </div>
    <div id="main" :style="`bottom:${bottom}`" @scroll="groupListScroll">
      <ul>
        <li v-for="(item, index) in tableData" :key="index" >
          <div class="list-row" @click="memberManage(item)">
            <div class="checkbox" v-show="isChoose" @click.stop="chooseOne(item)"
                 :class="{'select': item.isSelected, 'unselect': !item.isSelected}">
            </div>
            <div class="list-left">
              <img class="head-img" alt="" :src="item.imgUrl"/>
            </div>
            <div class="list-center1">
              <div class="groupName">{{item.groupName}}</div>
              <div class="userCount">{{item.userCount}}人</div>
            </div>
            <div class="list-right"><i class="more" :class="{'transform':item.isTransform}"
                                       @click.stop="xialaClick(item)"></i></div>
          </div>
          <div class="xiala-div toolbar" v-show="item.isXiala">
            <div class="operation" @click="isDialogShow = true;newGroupName = item.groupName;selectRow.isRename = true">
              <i class="iconfont icon-bianjibiaoge" />
              <div>重命名</div>
            </div>
            <div class="operation" @click="deleteGroup(item)">
              <i class="iconfont icon-lajitong"/>
              <div>删除</div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div id="footer-shade" v-show="isChoose&&!selectCount">

    </div>
    <div id="footer" class="toolbar" v-show="isChoose">
      <button @click="deleteGroup(null)">删除</button>
    </div>
    <div class="dialog" v-show="isDialogShow" v-if="false">
      <div class="dialog-title">群组名称</div>
      <div class="dialog-content">
        <input v-model="newGroupName" :placeholder="placeholder"/>
      </div>
      <div class="dialog-footer">
        <div class="dialog-left" @click="isDialogShow = false; newGroupName = '';selectRow.isRename = false">取消</div>
        <div class="dialog-right" @click="addGroup">确定</div>
      </div>
    </div>
    <div id="shade" v-show="isShadeShow" v-if="false"></div>
    <div class="dialog" v-show="deleteTrigger">
      <div class="dialog-title">删除</div>
      <div class="dialog-content">
        <span class="content">确认删除所选群组？</span>
      </div>
      <div class="dialog-footer">
        <div class="dialog-left" @click="deleteTrigger = false;ids = []">取消</div>
        <div class="dialog-right" @click="confirmDelete">确定</div>
      </div>
    </div>
  </div>
</template>
<script>
  import apis from '@/apis/cloudStorageApi'
  import ajax from '@/apis/index'
  import {Toast, MessageBox} from 'mint-ui'

  const baseUrl = ajax.app.cloudStorage.baseUrl
  const imgUrl = baseUrl + '/api/userGroup/icon/get'

  export default {
    data () {
      return {
        tableData: [],
        isChoose: false, // 是否触发勾选
        isChooseAll: false,
        selectCount: 0,
        ids: [], // 需要操作的行
        selectRow: {},
        deleteTrigger: false, // 删除确认触发
        page: {
          pageNo: 0,
          pageSize: 20,
          totalElements: 0
        },
        isDialogShow: false,
        newGroupName: '新增群组',
        placeholder: '请输入群组名称'
      }
    },
    created () {
      this.tableInit()
    },
    watch: {
      isDialogShow (val) {
        console.log(1);
        if (val) {
          MessageBox.prompt('新增群组', '', {
            showInput: true,
            inputValue: this.newGroupName,
            inputPattern: /^.{1,10}$/,
            inputErrorMessage: '名字长度为1-10个字符'
          }).then(({value, action}) => {
            this.newGroupName = value
            this.addGroup()
            this.isDialogShow = false
          }).catch(() => {
            this.isDialogShow = false
          })
        }
      }
    },
    computed: {
      bottom () {
        return this.isChoose ? '0.98rem' : 0
      },
      isShadeShow () {
        return this.isDialogShow || this.deleteTrigger
      }
    },
    methods: {
      groupListScroll () {
        const content = document.getElementById('main')
        if (content.scrollHeight - content.scrollTop - content.offsetHeight < 10) {
          if (this.page.totalElements > this.tableData.length) {
            this.queryGroupList()
          }
        }
      },
      // 成员管理
      memberManage (item) {
        this.$router.push({path: '/memberManage', query: {groupName: item.groupName, groupId: item.id}})
      },
      // 新增群组
      addGroup () {
        if (!this.newGroupName && this.newGroupName !== 0) {
          Toast({
            message: '请输入群组名称',
            iconClass: 'icon-error'
          })
        }
        if (this.selectRow.isRename && this.selectRow.groupName === this.newGroupName) {
          this.isDialogShow = false
          this.selectRow.isRename = false
          return false
        }
        const isDuplication = this.tableData.some((row, index, array) => {
          if (row.groupName === this.newGroupName) {
            Toast({
              message: '群组重名，请重新输入',
              iconClass: 'icon-error'
            })
            return true
          }
          return false
        })
        if (isDuplication) {
          return true
        }
        if (!this.selectRow.isRename) {
          ajax.request(apis.addGroup, {groupName: this.newGroupName}).then(() => {
            this.isDialogShow = false
            this.newGroupName = '新增群组'
            this.tableInit()
            Toast({
              message: '新增成功',
              iconClass: 'icon-success'
            })
          })
        } else {
          ajax.request(apis.modifyGroup, {id: this.selectRow.id, groupName: this.newGroupName}).then(() => {
            this.isDialogShow = false
            this.selectRow.isRename = false
            this.selectRow.groupName = this.newGroupName
            this.newGroupName = ''
            Toast({
              message: '重命名成功',
              iconClass: 'icon-success'
            })
          })
        }
      },
      // 触发checkbox显示
      triggerChoose () {
        this.isChoose = true
        if (this.selectRow.isXiala) {
          this.selectRow.isXiala = !this.selectRow.isXiala
          this.selectRow.isTransform = !this.selectRow.isTransform
        }
      },
      // 删除选中群组
      confirmDelete () {
        ajax.request(apis.deleteGroup, {ids: this.ids.join(',')}).then(() => {
          Toast({
            message: '删除成功',
            iconClass: 'icon-success'
          })
          this.deleteTrigger = false
          this.selectCount = 0
          this.tableData = this.tableData.filter((row, index, array) => {
            // 将未删除的数据重新赋值给列表数据
            if (this.ids.indexOf(row.id) === -1) {
              // 重新计算选中个数
              if (row.isSelected) {
                this.selectCount++
              }
              return true
            }
            return false
          })
          this.ids = []
          if (!this.tableData.length) {
            this.isChoose = false
          }
        })
      },
      // 存储需要删除的行并弹出确认操作
      deleteGroup (item) {
        if (item) {
          this.ids.push(item.id)
        } else {
          this.tableData.forEach((value, index, array) => {
            if (value.isSelected) {
              this.ids.push(value.id)
            }
          })
        }
        this.deleteTrigger = true
      },
      // 点击下拉图标
      xialaClick (item) {
        if (!item.isXiala) {
          if (this.selectRow.isXiala) {
            this.selectRow.isXiala = !this.selectRow.isXiala
            this.selectRow.isTransform = !this.selectRow.isTransform
          }
          this.selectRow = item
        }
        item.isXiala = !item.isXiala
        item.isTransform = !item.isTransform
      },
      // 列表数据初始化
      tableInit () {
        this.tableData = []
        this.page.pageNo = 0
        this.page.totalElements = 0
        this.queryGroupList()
      },
      queryGroupList () {
        ajax.request(apis.groupList, {
          page: this.page.pageNo,
          size: this.page.pageSize
        }).then((response) => {
          response.data.content.forEach((row, index, array) => {
            row.isSelected = false
            row.isXiala = false
            row.isTransform = false
            row.imgUrl = imgUrl + '?id=' + row.id
          })
          this.tableData = this.tableData.concat(response.data.content)
          this.page.totalElements = response.data.totalElements
        })
        this.page.pageNo++
      },
      // 返回
      returnBack () {
        this.$router.push('/more/setinfo')
      },
      // 全选或取消全选
      choose () {
        if (this.isChooseAll) {
          this.cancleChooseAll()
        } else {
          this.chooseAll()
        }
      },
      // 取消全选
      cancleChooseAll () {
        this.selectCount = 0
        this.isChooseAll = false
        this.tableData.forEach((row, index, array) => {
          row.isSelected = false
        })
      },
      // 全选
      chooseAll () {
        this.selectCount = this.tableData.length
        this.isChooseAll = true
        this.tableData.forEach((row, index, array) => {
          row.isSelected = true
        })
      },
      cancle () {
        this.isChoose = false
        if (this.selectRow.isXiala) {
          this.selectRow.isXiala = !this.selectRow.isXiala
          this.selectRow.isTransform = !this.selectRow.isTransform
        }
        this.cancleChooseAll()
      },
      chooseOne (item) {
        if (item.isSelected) {
          item.isSelected = false
          this.selectCount--
          if (this.isChooseAll) {
            this.isChooseAll = false
          }
        } else {
          item.isSelected = true
          this.selectCount++
          if (this.selectCount === this.tableData.length) {
            this.isChooseAll = true
          }
        }
      }
    }
  }
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
  @import "../../assets/css/variable";

  #group-wrap {
    background-color: $white;
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
    font-family: PingFangSC-Medium;
    #shade {
      opacity: 0.5;
      background: #000000;
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      z-index: 100;
    }
    .dialog {
      background: $white;
      border-radius: 0.08rem;
      width: 5.6rem;
      position: absolute;
      z-index: 101;
      left: 0.95rem;
      top: 5.22rem;
      .dialog-title {
        font-family: PingFangSC-Regular;
        font-size: $fontsize-lg;
        color: #1D1F22;
        padding-top: 0.5rem;
        text-align: center;
      }
      .dialog-content {
        margin: 0.27rem 0 0.3rem 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        .content {
          text-align: center;
          font-family: PingFangSC-Regular;
          font-size: $fontsize-md;
          color: #9B9B9B;
        }
        input {
          height: 0.56rem;
          font-family: PingFangSC-Regular;
          font-size: $fontsize-md;
          color: #999999;
          letter-spacing: 0.28px;
          background: $white;
          border: 1px solid #E6E6EA;
          border-radius: 0.1rem;
          padding: 0.15rem 0.2rem;
        }
      }
      .dialog-footer {
        height: 0.98rem;
        .dialog-left, .dialog-right {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          text-align: center;
          font-family: PingFangSC-Regular;
          font-size: $fontsize-lg;
          float: left;
          border-top: 1px solid #E6E6EA;
          width: 2.795rem;
          height: 100%;
        }
        .dialog-left {
          color: #1D1F22;
          border-right: 0.01rem solid #E6E6EA;
        }
        .dialog-right {
          color: $theme-color;
        }
        .dialog-right::after {
          clear: both;
        }
      }
    }
    #header {
      padding-top: 0.28rem;
      width: 100%;
      position: absolute;
      height: 1.28rem;
      z-index: 2;
      .topbar {
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        padding: 0.19rem 0.31rem;
        color: $white;
        letter-spacing: 0;
        line-height: 0.5rem;
        .top-center {
          font-size: $fontsize-lg;
          font-family: PingFangSC-Medium;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .top-left, .top-right {
          font-size: $fontsize-md;
          font-family: PingFangSC-Regular;
        }
        > div {
          display: inline-block;
          span, i {
            vertical-align: middle;
          }
        }
        .top-left {
          width: 2rem;
          text-align: left;
          .back {
            width: .2rem;
            height: .3rem;
            background: url("../../assets/images/back.png") no-repeat;
            background-size: .2rem .31rem;
            float: left;
            margin-top: .1rem;
          }
        }
        .top-center {
          text-align: center;
        }
        .top-right {
          width: 2rem;
          text-align: right;
          i {
            display: inline-block;
            width: 0.36rem;
            height: 0.36rem;
          }
          .open-mobile {
            margin-right: 0.29rem;
          }
        }
      }
    }
    #main {
      overflow: auto;
      width: 100%;
      position: absolute;
      top: 1.28rem;
      &::-webkit-scrollbar {
        width: 0px;
        opacity: 0;
        -webkit-overflow-scrolling: touch;
      }
      ul {
        > li {
          border-bottom: 0.01rem solid #E5E5E5;
          padding-bottom: 0.01rem;
          >div{
            height: 0.98rem;
          }
          > .list-row {
            display: flex;
            flex-direction: row;
            align-items: center;
            background-color: $white;
            width: 100%;
            padding: 0 0.36rem;
            .checkbox {
              margin-right: 0.36rem;
              width: 0.24rem;
              height: 0.24rem;
              border-radius: 50%;
            }
            .select {
              background: url(../../assets/images/success_big.png) center no-repeat;
              background-size: 0.24rem 0.24rem;
              border: none;
            }
            .unselect {
              border: 0.01rem solid #979797;
            }
            > div {
              display: inline-block;
              .head-img {
                display: inline-block;
                width: 0.64rem;
                height: 0.64rem;
                background-size: 100% 100%;
                background-image: url(../../assets/images/defaultPic.png)
              }
            }
            .list-left {
              max-width: 2rem;
              width: 20%
            }
            .list-center1 {
              .groupName {
                font-family: PingFangSC-Regular;
                font-size: $fontsize-md;
                color: #1D1F22;
                letter-spacing: 0;
                max-width: 4rem;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              .userCount {
                font-family: PingFangSC-Regular;
                font-size: $fontsize-xs;
                color: #9B9B9B;
              }
            }
            .list-right {
              margin-right: 0;
              margin-left: auto;
              .transform {
                transform: rotate(180deg);
              }
            }
          }
          .xiala-div {
            width: 100%;
            height: 0.98rem;
            background-color: #F7F7FA;
            padding: 0 2.14rem;
            justify-content: space-between;
          }
        }
      }
    }
    #footer {
      width: 100%;
      position: absolute;
      height: 0.98rem;
      bottom: 0;
      top: auto;
      background-color: #3F4B5F;
      color: $white;
      font-size: $fontsize-sm;
      justify-content: center;
      padding: 0.09rem 0.4rem;
      button {
        background: #E4393C;
        border-radius: 0.1rem;
        border: 0;
        width: 100%;
        height: 100%;
        color: $white;
        font-family: PingFangSC-Regular;
        font-size: $fontsize-lg;
      }
    }
    #footer-shade {
      width: 100%;
      position: absolute;
      height: 0.98rem;
      bottom: 0;
      top: auto;
      background: #3F4B5F;
      z-index: 100;
      opacity: 0.4;
    }
  }

  .check-mobile {
    background: url("../../assets/images/check-mobile.png") center no-repeat;
    background-size: 0.36rem 0.36rem;
  }

  .open-mobile {
    background: url("../../assets/images/open-mobile.png") center no-repeat;
    background-size: 0.36rem 0.36rem;
  }

  .more {
    display: inline-block;
    width: 0.2rem;
    height: 0.26rem;
    background: url("../../assets/images/down.png") center no-repeat;
    background-size: 0.18rem 0.12rem;
  }

  .toolbar {
    display: flex;
    flex-direction: row;
    align-items: center;
    .operation {
      text-align: center;
      > div {
        text-align: center;
      }
      img {
        width: 0.34rem;
        height: 0.36rem;
        color: $white;
      }
    }
  }
  .iconfont{
    font-size: 0.48rem;
    color: #999999;
  }
</style>



// WEBPACK FOOTER //
// src/views/group/list.vue